import React, {Component} from 'react'
import {Link} from 'react-router-dom'

import Header from "../components/Header";
import Footer from '../components/Footer'

const Terms = () => (
    <div>
        <Header/>
        <div className="content partslist-page">
            <div className="container">
                <div className="pb-5">
                    <h1 className="title-partslist-page">ご利用規約</h1>
                    <div className="img-three-dot">
                        <img src="images/three-dot.png" className="img-fluid"/>
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>【重要】 ご利用される前に、下記ご利用規約をよくお読みください。</span>
                    </h2>
                    <div className="description-item-parts mb-5">
                        規約には、本サービスを使用するに当たってのあなたの権利と義務が規定されております。<br/>
                        会員登録の際は、「同意して会員登録へ」ボタンをクリックすると、あなたが本規約の全ての条件に同意したことになります。
                    </div>
                    <div>
                        第1条（利用規約の目的及び適用）<br/>
                        <br/>
                        株式会社dsc（以下、「当社」といいます。）は、利用規約（以下、「本規約」といいます。）に基づき「サシイレ」（ 以下、「本サービス」といいます。） を提供します。<br/>
                        当社は、本規約に関する条項の追加、削除、特約等の条件または本サービスに関する説明（以下、「個別規定」といいます。）を別途定めることがあります。この場合、個別規定は本規約の一部を構成するものとし、本規約と個別規定との間に齟齬が生じた場合は、個別規定が本規約に優先して適用されるものとします。<br/>
                        <br/>
                        第2条 (会員資格の喪失及び賠償義務)<br/>
                        <br/>
                        1. 会員が、会員資格取得申込の際に虚偽の申告をしたとき、通信販売による代金支払債務を怠ったとき、その他当社が会員として不適当と認める事由があるときは、当社は、会員資格を取り消すことができることとします。<br/>
                        2. 会員が、以下の各号に定める行為をしたときは、これにより「当社が被った損害」を賠償する責任を負います。<br/>
                        (1)会員番号、パスワードを不正に使用した場合<br/>
                        (2)当ホームページにアクセスして情報を改ざんしたり、当ホームページに有害なコンピュータープログラムを送信するなどして、当社の営業を妨害した場合<br/>
                        (3)当社が扱う商品の知的所有権を侵害する行為をした場合<br/>
                        (4) 暴力団その他の反社会的勢力の構成員もしくはこれに準ずる者であり、または過去においてこれらの者であった場合<br/>
                        (5) 料金等の債務の履行遅滞または履行不能が発生した場合<br/>
                        (6) 本規約に違反した場合<br/>
                        その他当社が不適切と判断する行為を行った場合<br/>
                        <br/>
                        第3条 (情報の取扱い)<br/>
                        <br/>
                        1. 当社は、原則として会員情報を会員の事前の同意なく第三者に対して開示することはありません。ただし、次の各号の場合には、会員の事前の同意なく、当社は会員情報その他のお客様情報を開示できるものとします。<br/>
                        (1)法令に基づき開示を求められた場合<br/>
                        (2)当社の権利、利益、名誉等を保護するために必要であると当社が判断した場合<br/>
                        (3)サシイレ先スポーツチームより情報開示を求められた場合<br/>
                        (4) その他当社が正当な理由をもって情報開示を必要であると判断した場合<br/>
                        <br/>
                        2. 会員情報につきましては、当社の「個人情報保護への取組み」に従い、当社が管理します。当社は、会員情報を、会員へのサービス提供、サービス内容の向上、サービスの利用促進、およびサービスの健全かつ円滑な運営の確保を図る目的のために、当社おいて利用することができるものとします。<br/>
                        3. 当社は、会員に対して、メールマガジンその他の方法による情報提供(広告を含みます)を行うことができるものとします。会員が情報提供を希望しない場合は、当社所定の方法に従い、その旨を通知して頂ければ、情報提供を停止します。ただし、本サービス運営に必要な情報提供につきましては、会員の希望により停止をすることはできません。<br/>
                        <br/>
                        第4条 (禁止事項)<br/>
                        <br/>
                        本サービスの利用に際して、会員に対し次の各号の行為を行うことを禁止します。<br/>
                        <br/>
                        1. 法令または本規約、本サービスご利用上のご注意、本サービスでのお買い物上のご注意その他の本規約等に違反すること<br/>
                        2. 当社、およびその他の第三者の権利、利益、名誉等を損ねること<br/>
                        3. 青少年の心身に悪影響を及ぼす恐れがある行為、その他公序良俗に反する行為を行うこと<br/>
                        4. 他の利用者その他の第三者に迷惑となる行為や不快感を抱かせる行為を行うこと<br/>
                        5. 虚偽の情報を入力すること<br/>
                        6. 有害なコンピュータープログラム、メール等を送信または書き込むこと<br/>
                        7. 当社のサーバーその他のコンピューターに不正にアクセスすること<br/>
                        8. パスワードを第三者に貸与・譲渡すること、または第三者と共用すること<br/>
                        その他当社が不適切と判断すること<br/>
                        <br/>
                        第5条 (個別契約の申込、成立等)<br/>
                        <br/>
                        申込者が、当社所定の方法により、差し入れ内容確認画面において「注文完了する」もしくは「次へ」ボタンをクリックした時点で、申込者の申込みが確定し、本取引が行われたものとします。<br/>
                        <br/>
                        第6条 (サービスの中断・停止等)<br/>
                        <br/>
                        1. 当社は、本サービスの稼動状態を良好に保つために、次の各号の一に該当する場合、予告なしに、本サービスの提供全てあるいは一部を停止することがあります。<br/>
                        (1)システムの定期保守および緊急保守のために必要な場合<br/>
                        (2)システムに負荷が集中した場合<br/>
                        (3)火災、停電、第三者による妨害行為などによりシステムの運用が困難になった場合<br/>
                        (4)その他、止むを得ずシステムの停止が必要と当社が判断した場合<br/>
                        <br/>
                        第7条 (サービスの変更・廃止)<br/>
                        <br/>
                        当社は、その判断によりサービスの全部または一部を事前の通知なく、適宜変更・廃止できるものとします。<br/>
                        <br/>
                        第8条 (免責)<br/>
                        <br/>
                        1. 通信回線やコンピューターなどの障害によるシステムの中断・遅滞・中止・データの消失、データへの不正アクセスにより生じた損害、その他当社のサービスに関して会員に生じた損害について、当社は一切責任を負わないものとします。<br/>
                        2. 当社は、当社のウェブページ・サーバー・ドメインなどから送られるメール・コンテンツに、コンピューター・ウィルスなどの有害なものが含まれていないことを保証いたしません。<br/>
                        3. 会員が本規約等に違反したことによって生じた損害については、当社は一切責任を負いません。<br/>
                        <br/>
                        第9条 (本規約の改定)<br/>
                        <br/>
                        当社は、本規約を任意に改定できるものとし、また、当社において本規約を補充する規約(以下「補充規約」といいます)を定めることができます。本規約の改定または補充は、改定後の本規約または補充規約を当社所定のサイトに掲示したときにその効力を生じるものとします。この場合、会員は、改定後の規約および補充規約に従うものと致します。<br/>
                        <br/>
                        第10条 (準拠法、管轄裁判所)<br/>
                        <br/>
                        当サイトならびに本規約の解釈および適用は、日本国法に準拠するものとします。本規約に関して紛争が生じた場合、当社本店所在地を管轄する地方裁判所を第一審の専属的合意管轄裁判所とします。
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
)

export default Terms